import React, { ChangeEvent, Component } from 'react';
import { ChartState } from '../../../../redux/reducers/ChartReducer';
import CustomLoading from '../../../custom/CustomLoading';
import { ChartType } from '@trlogic/ui-pack';
import { RootState } from '../../../../redux/store';
import { changeChart, changeChartEditorOptions, changeIsUpdate, clearChart } from '../../../../redux/actions/ChartActions';
import { enterComponent, leaveComponent } from '../../../../redux/actions/ComponentActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { SegmentItem } from '../../../../domain/chart/ChartDomains';
import FormicaInput from 'components/custom/FormicaInput';
import FormicaColorPalette from '../../../custom/color-palette/FormicaColorPalette';
import { FormicaSelectBoxItem } from '../../../custom/FormicaSearchSelectBox';
import LanguageUtil from '../../../../util/LanguageUtil';

class GroupByAppearance extends Component<Props> {
  render() {
    const {
      segmentItem,
      isBreakdown,
      chart: { chart },
    } = this.props;
    const appearance = segmentItem ? segmentItem.segments.groupBy?.appearance : null;
    if (appearance == null) return <CustomLoading />;
    return (
      <div className={`flex flex-col w-full bg-[#F7F8FA] items-start gap-y-4 `}>
        <p className={'text-lg text-primary font-semibold'}>{LanguageUtil.get({ id: 'common.label.appearance', defaultMessage: 'Appearance' })}</p>
        <div className={'flex flex-col w-full '}>
          <label className={'text-sm text-f-black-2'}>{LanguageUtil.get({ id: 'common.label.displayName', defaultMessage: 'Display Name' })}</label>
          <FormicaInput value={appearance.name} onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeAppearanceName(e)}></FormicaInput>
        </div>
        <div className={'flex flex-col w-full '}></div>
      </div>
    );
  }

  private onChangeColorPalette = (color: string[]) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    if (segmentItem?.segments.dateHistogram) {
      segmentItem.colorPalette = color;
      onChangeSegmentItem(segmentItem);
    }
  };

  private onChangeAppearanceName = (e: ChangeEvent<HTMLInputElement>) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const groupBySegment = segmentItem ? segmentItem.segments.groupBy : null;
    if (segmentItem && groupBySegment != null) {
      groupBySegment.appearance.name = e.currentTarget.value;
      segmentItem.name = e.currentTarget.value;
      onChangeSegmentItem(segmentItem);
    }
  };

  private onChangeAppearanceValueFormat = (e: FormicaSelectBoxItem) => {
    // TODO
    const { segmentItem, onChangeSegmentItem } = this.props;
    const groupBySegment = segmentItem ? segmentItem.segments.groupBy : null;
    if (segmentItem && groupBySegment != null) {
      onChangeSegmentItem(segmentItem);
    }
  };
}

interface Props extends ReduxProps {
  segmentItem: SegmentItem | null;
  onChangeSegmentItem: (segmentItem: SegmentItem) => void;
  isBreakdown: boolean;
}

const mapStateToProps = (state: RootState) => ({
  chart: state.chart as ChartState,
});

const mapDispatchToProps = { changeChart, changeChartEditorOptions, changeIsUpdate, enterComponent, leaveComponent, clearChart };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(GroupByAppearance);
